<template>
    <div class="vue-admin">
        <div class="header-banner"><h1>Create Media & Resources &mdash; Admin</h1></div>
        <div class="page-space">
            <div class="ui secondary segment">
                <form :class="'ui small form' + (error ? ' error': '')" @submit="saveModel($event)">
                    <div :class="'field' + (fieldErrors.title ? ' error' : '')">
                        <label for="model-title">Title</label>
                        <error-tag :error="fieldErrors.title" direction="below"></error-tag>
                        <input id="model-title" v-model="model.title" required>
                    </div>
                    <div :class="'field' + (fieldErrors.type ? ' error' : '')">
                        <label for="model-type">Type</label>
                        <error-tag :error="fieldErrors.type" direction="below"></error-tag>
                        <div class="select-arrow">
                            <select id="model-type" v-model="model.type" required>
                                <option value="in-the-news">In the News</option>
                                <option value="market-trends">Market Trends</option>
                                <option value="research-publications">Research Publications</option>
                                <option value="top-transactions">Top Transactions</option>
                                <option value="awards-recognitions">Awards &amp; Recognitions</option>
                            </select>
                        </div>
                    </div>
                    <div :class="'field' + (fieldErrors.date ? ' error' : '')">






                        <label for="model-date">Date</label>
                        <error-tag :error="fieldErrors.datefield" direction="below"></error-tag>
                        <input id="model-datefield" type="date" v-model="model.datefield">







                    </div>
                    <div :class="'field medium-field' + (fieldErrors.blurb ? ' error' : '')">
                        <label for="model-blurb">Blurb</label>
                        <error-tag :error="fieldErrors.blurb" direction="below"></error-tag>
                        <ckeditor id="model-blurb" v-model="model.blurb">The short description shown on the index page.</ckeditor>
                    </div>
                    <div class="ui segment">
                        <div class="ui segment secondary">
                            <label>Link action</label>
                            <div class="inline fields">
                                <div class="field">
                                    <div class="ui radio checkbox">
                                        <input id="model-link-link" type="radio" name="link-action" value="link" v-model="link_action">
                                        <label for="model-link-link">Link</label>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="ui radio checkbox">
                                        <input id="model-link-post" type="radio" name="link-action" value="body" v-model="link_action">
                                        <label for="model-link-post">Post body</label>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="ui radio checkbox">
                                        <input id="model-link-file" type="radio" name="link-action" value="file" v-model="link_action">
                                        <label for="model-link-file">Choose or upload a file</label>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="ui radio checkbox">
                                        <input id="model-link-none" type="radio" name="link-action" value="none" v-model="link_action">
                                        <label for="model-link-none">None</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ui segment secondary">
                            <div :class="'field' + (fieldErrors.link ? ' error' : '')" v-if="link_action==='link'">
                                <label for="model-link">Link</label>
                                <error-tag :error="fieldErrors.link" direction="below"></error-tag>
                                <input id="model-link" v-model="model.link" required>
                            </div>
                            <div :class="'field' + (fieldErrors.body ? ' error' : '')" v-if="link_action==='body'">
                                <label for="model-body">Body</label>
                                <error-tag :error="fieldErrors.body" direction="below"></error-tag>
                                <div class="media-resources-body">
                                    <ckeditor id="model-body" v-model="model.body"></ckeditor>
                                </div>
                            </div>
                            <div :class="'field' + (fieldErrors.link_file ? ' error' : '')" v-if="link_action==='file'">
                                <label>File</label>
                                <error-tag :error="fieldErrors.link_file" direction="below"></error-tag>
                                <input type="file" ref="linkfileupload" @change="clearLinkExisting" required>
                                <choose-file folder="media-resources" v-on:picked="linkExistingFile"></choose-file>
                            </div>
                            <div :class="'field'" v-if="link_action==='none'">
                            </div>
                        </div>
                    </div>

                    <div class="ui segment">
                        <label>Photo</label>
                        <p><small>Recommended file size is 400px wide by 150-300px tall.</small></p>
                        <div class="ui grid">
                            <div class="ten wide column">
                                <div :class="'field' + (fieldErrors.photo ? ' error' : '')">
                                    <div class="ui segment secondary">
                                        <error-tag :error="fieldErrors.photo" direction="below"></error-tag>
                                        <input type="file" ref="filepicker" id="model-photo-upload" @change="imagePreview">
                                        <choose-file folder="media-resources" :photo_only="true" v-on:picked="chooseExistingFile"></choose-file>
                                    </div>
                                </div>
                            </div>
                            <div class="six wide column">
                                <div class="ui segment secondary">
                                    <img alt="default" :src="model.upload ? model.upload.preview : (model.photo ?model.photo.folder + model.photo.file:'/img/default.jpg?v=1')">
                                    <br>
                                    <button class="ui small grey button" type="button" v-on:click="clearPhoto" v-if="model.photo || model.upload"><i class="erase icon"></i> Clear photo</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <error-display v-if="error" :error="error"></error-display>
                    <p>
                        <button type="submit" :class="'ui small green submit button' + (saving?' loading ':'')">Save Media</button>
                    </p>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import ErrorDisplay from "../errorDisplay";
    import ErrorTag from "../errorTag";
    import ChooseFile from "../chooseExistingFile";
    import Ckeditor from 'vue-ckeditor2';
    import Datepicker from 'vuejs-datepicker';
    import Moment from 'vue-moment';

    export default {
        components: {
            ErrorTag, ErrorDisplay, ChooseFile,Ckeditor,Datepicker},
        data: function(){
            return {
                model: {
                    title:'',
                    type:'news',
                    blurb:'',
                    link:'',
                    datefield: new Date(),
                    photo: null,
                },
                link_action: 'file',
                error: null,
                fieldErrors: {},
                saving: false
            };
        },
        mounted(){
            document.title = 'Create Media & Resources — Admin | ' + document.title.split(' | ').pop();
        },
        computed: {
            datefield: {
                get() {
                    return Moment.moment(datefield,'MM/DD/YYYY');
                },
                set(date) {
                    this.model.datefield = Moment.moment(date, 'MM/DD/YYYY');
                }
            }
        },
        methods: {
            linkExistingFile(folder, file){
                this.$refs.linkfileupload.value = '';
                this.model.link = folder + file;
                this.link_action = 'link';
            },
            clearLinkExisting(){
                this.model.link = null;
            },
            chooseExistingFile(folder, file){
                this.$refs.filepicker.value = '';
                this.model.upload = null;
                let image = new Image();
                image.onload = ()=>{
                    let padding = (100 / image.naturalWidth * image.naturalHeight).toFixed(2) + '%';
                    this.model.photo = {folder, file, padding};
                };
                image.src = folder + file;
            },
            clearPhoto(){
                this.$refs.filepicker.value = '';
                this.model.upload = null;
                this.model.photo = null;
                this.$forceUpdate();
            },
            saveModel(event){
                event.preventDefault();
                this.saving = true;
                let data = new FormData();
                this.fieldErrors = {};
                data.append('title',this.model.title);
                data.append('type',this.model.type);
                data.append('date',this.model.datefield);
                data.append('blurb',this.model.blurb);
                data.append('link_action',this.link_action);
                switch (this.link_action){
                    case 'link':
                        data.append('link',this.model.link);
                        break;
                    case 'body':
                        data.append('body',this.model.body);
                        break;
                    case 'file':
                        data.append('link_file',this.$refs.linkfileupload.files[0]);
                        break;
                }
                let options = {};
                if(this.model.upload || this.link_action === 'file')
                    options = {headers: { 'Content-Type': 'multipart/form-data' }};
                if(this.model.upload){
                    data.append('upload',this.model.upload.file);
                    data.append('padding',this.model.upload.padding);
                } else if(this.model.photo) {
                    data.append('photo[folder]',this.model.photo.folder);
                    data.append('photo[file]',this.model.photo.file);
                    data.append('padding',this.model.photo.padding);
                }
                axios.post('/admin/api/media', data, options)
                    .then((response)=>{
                        if(response.status === 200){
                            this.$router.push('/admin/media/'+response.data.id+'/edit');
                        } else {
                            this.error = {header:'Error: '+response.statusText,message:response.data}
                        }
                    }).catch((error)=>{
                        if(error.response){
                            if(error.response.status === 400){
                                this.fieldErrors = error.response.data.errors;
                            } else {
                                this.error = {header:'Error', message:error.response.statusText};
                            }
                        }
                    }).then(()=>{this.saving = false;});
            },
            imagePreview: function(){
                let input = this.$refs.filepicker;
                if(input.files[0]){
                    this.model.upload = {file:input.files[0]};
                    let reader = new FileReader();
                    reader.onload = (e)=>{
                        let image = new Image();
                        image.onload = ()=>{
                            this.model.upload.padding = (100 / image.naturalWidth * image.naturalHeight).toFixed(2) + '%';
                            this.model.upload.preview = image.src;
                            this.$forceUpdate();
                        };
                        image.src = e.target.result;
                    };
                    reader.readAsDataURL(input.files[0]);
                }
            },

        }
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/admin/media-resources/create.vue